
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"49","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M24.5 0C38.03 0 49 10.97 49 24.5S38.03 49 24.5 49 0 38.03 0 24.5 10.97 0 24.5 0","fill":"#005149"}}),_c('path',{attrs:{"d":"M39 15.605a11.221 11.221 0 01-3.182.875 5.535 5.535 0 002.433-3.076 10.987 10.987 0 01-3.515 1.347 5.524 5.524 0 00-7.827-.244 5.572 5.572 0 00-1.747 4.045c.001.426.05.85.141 1.268a15.727 15.727 0 01-11.414-5.774 5.569 5.569 0 001.7 7.395 5.543 5.543 0 01-2.512-.694v.074a5.552 5.552 0 004.446 5.443c-.817.22-1.67.253-2.502.095a5.537 5.537 0 005.17 3.858A11.095 11.095 0 0112 32.504 15.582 15.582 0 0020.504 35c10.203 0 15.751-8.462 15.751-15.8v-.722A11.263 11.263 0 0039 15.605","fill":"#FFF"}})])])
          )
        }
      }
    